



































































































































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import {
  Alert, NoticeClass, Dialog,
} from '@kasasa/fbase-components/lib';
import {
  CycleValidationFile, CycleValidationPostingFile, CycleValidationReportFile, CycleValidationApproval, PostingFileResource, FileResource,
} from '@/api/rewardsvalidation/';
import { CoreUserInfoResource, CoreUserInfo } from '@/api/coreuserinfo/';


@Component({ computed: mapState(['fiId']) })
export default class PostingFilesCard extends Vue {
  @Prop() cycleId!: number;

  @Prop() snapshotId: number | undefined;

  @Prop({ default: 'Posting and Posting Report Files' }) title!: string;

  @Prop({ default: 'Posting Files' }) postingFilesSubHeader!: string;

  @Prop({ default: 'Posting Report Files' }) reportFilesSubHeader!: string;

  @Prop() fileSource: PostingFileResource | undefined;

  @Prop({ default: 'No files expected' }) noFilesExpectedMessage!: string;

  fiId!: string;

  postingFiles: CycleValidationPostingFile[] = [];

  reportFiles: CycleValidationReportFile[] = [];

  loadingPostingFiles: boolean = false;

  loadingReportFiles: boolean = false;

  errorLoadingReportFiles: boolean = false;

  loadingZeroByteApproval = false;

  saving: boolean = false;

  hasMissingFile: boolean = false;

  hasOutOfDateReportFile: boolean = false;

  hasZeroByteFile: boolean = false;

  zeroByteApproval: CycleValidationApproval | null = null;

  zeroByteApprovalUserName: string | null = null;

  hasUnapprovedZeroByteFiles: boolean | null = null;

  filesExpected: boolean = true;

  @Inject('CoreUserInfoResource')
  coreUserInfoResource!: CoreUserInfoResource;

  headers: DataTableHeader[] = [
    { text: 'File Name', value: 'fileName', width: '400px' },
    { text: 'File Created', value: 'fileCreated', width: '300px' },
    { text: 'File Size', value: 'fileSizeDisplay', width: '100px' },
    { text: '', value: 'error' },
  ];

  mounted() {
    this.loadFiles();
  }

  @Watch('cycleId')
  @Watch('snapshotId')
  loadFiles() {
    this.loadingPostingFiles = true;
    this.loadingReportFiles = true;

    this.hasMissingFile = false;
    this.hasOutOfDateReportFile = false;
    this.hasZeroByteFile = false;
    this.zeroByteApproval = null;
    this.zeroByteApprovalUserName = null;
    this.filesExpected = true;

    if (this.fileSource) {
      this.checkIfFilesExpected(this.fileSource);
      this.loadPostingFiles(this.fileSource);
      this.loadReportFiles(this.fileSource);
    }
  }

  async checkIfFilesExpected(fileResource: FileResource) {
    fileResource.filesExpected(this.fiId).then((expected: boolean) => {
      this.filesExpected = expected;
    }).catch((error: any) => {
      this.showErrorMessage(error);
    });
  }

  loadPostingFiles(fileSource: FileResource) {
    fileSource.getFiles(this.fiId, this.cycleId).then((results: CycleValidationPostingFile[]) => {
      this.postingFiles = results;

      this.postingFiles.forEach((file: CycleValidationPostingFile) => {
        if (!file.fileCreated) {
          this.hasMissingFile = true;
        } else if (file.fileSizeBytes === 0) {
          this.hasZeroByteFile = true;
        }
      });

      if (!this.hasZeroByteFile) {
        this.hasUnapprovedZeroByteFiles = false;
      } else {
        this.loadZeroByteApproval();
      }

      this.$emit('loadedFiles', this.postingFiles, this.hasMissingFile);
    }).catch((error: any) => {
      if (error.response && error.response.status !== 404) {
        this.showErrorMessage(error);
      }
      this.postingFiles = [];
    }).finally(() => {
      this.loadingPostingFiles = false;
    });
  }

  loadReportFiles(fileResource: FileResource) {
    fileResource.getReportFiles(this.fiId, this.cycleId).then((results: CycleValidationReportFile[]) => {
      // sorts list of reports by file creation datetime ascending
      results.sort((a, b) => {
        // place files which are not ready at the front of the list so they can be visible on the first table page
        if (a.isLatestVersionReady !== b.isLatestVersionReady) {
          return a.isLatestVersionReady ? 1 : -1;
        }
        return a.fileCreatedMillis - b.fileCreatedMillis;
      });
      this.reportFiles = results;
      this.hasOutOfDateReportFile = false;
      this.reportFiles.forEach((file: CycleValidationReportFile) => {
        if (!file.isLatestVersionReady) {
          this.hasOutOfDateReportFile = true;
        }
      });
    }).catch((error: any) => {
      if (error.response && error.response.status !== 404) {
        this.showErrorMessage(error);
        this.errorLoadingReportFiles = true;
      }
      this.reportFiles = [];
    }).finally(() => {
      this.$emit('loadedReportFiles', this.reportFiles, this.hasOutOfDateReportFile);
      this.loadingReportFiles = false;
    });
  }

  loadZeroByteApproval() {
    if (this.snapshotId) {
      this.loadingZeroByteApproval = true;

      if (this.fileSource) {
        this.fileSource.getZeroByteApproval(this.fiId, this.snapshotId).then((result: CycleValidationApproval) => {
          this.zeroByteApproval = result;
          this.fetchZeroByteApprovalUserName();
          this.hasUnapprovedZeroByteFiles = false;
        }).catch((error: any) => {
          if (error.response && error.response.status !== 404) {
            this.showErrorMessage(error);
          } else {
            this.hasUnapprovedZeroByteFiles = true;
          }
        }).finally(() => {
          this.loadingZeroByteApproval = false;
        });
      }
    }
  }

  fetchZeroByteApprovalUserName() {
    if (this.zeroByteApproval && this.zeroByteApproval.approvalUserId) {
      this.coreUserInfoResource.getCoreUserInfo(this.fiId, this.zeroByteApproval.approvalUserId).then((user: CoreUserInfo) => {
        let userName: string = '';

        if (user.firstName && user.firstName.length > 0) {
          userName = user.firstName;
          if (user.lastName && user.lastName.length > 0) {
            userName += ' ';
          }
        }

        if (user.lastName && user.lastName.length > 0) {
          userName += user.lastName;
        }

        if (userName.length === 0) {
          userName = 'User';
        }

        this.zeroByteApprovalUserName = userName;
      }).catch((error: any) => {
        this.zeroByteApprovalUserName = 'User';
        this.showErrorMessage(error);
      });
    }
  }

  getFileDownloadUri(s3Key: string): string {
    return `/api/rcx/reporting/${this.fiId}/s3key-download/${this.cycleId}?s3key=${encodeURIComponent(s3Key)}`;
  }

  downloadPostingFile(file: CycleValidationFile) {
    this.downloadFile(file, 'The posting file you were trying to view does not exist.', 'This may be because processing for that FI has not succeeded for the selected cycle, or this FI has not been white-listed for KRP processing.');
  }

  downloadReportFile(file: CycleValidationFile) {
    this.downloadFile(file, 'Error occurred while trying access the report file you were trying to view.', 'An unexpected error occurred, please try again later.');
  }

  downloadFile(file: CycleValidationFile, errorDialogTitle: string, errorDialogMessage: string) {
    const uri = this.getFileDownloadUri(file.s3Key);
    this.$http.get(uri).then(() => {
      window.location.href = uri;
    }).catch((error: any) => {
      const dialog = new Dialog(errorDialogTitle, errorDialogMessage);
      dialog.setAcceptLabel('OK')
        .setDismissable(false);

      this.$store.dispatch('notices/add', dialog);
    });
  }

  approveZeroByte() {
    if (this.snapshotId && this.fileSource) {
      this.saving = true;
      this.fileSource.saveZeroByteApproval(this.fiId, this.snapshotId).then((result: CycleValidationApproval) => {
        this.zeroByteApproval = result;
        this.fetchZeroByteApprovalUserName();
        this.hasUnapprovedZeroByteFiles = false;
      }).catch((error: any) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.saving = false;
      });
    }
  }

  @Watch('hasUnapprovedZeroByteFiles')
  onZeroByteFileApprovalStatusChange() {
    this.$emit('zeroByteApprovalStatusChange', this.hasUnapprovedZeroByteFiles);
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
